import { render } from "./DemoStorage.vue?vue&type=template&id=3484ac58"
import script from "./DemoStorage.vue?vue&type=script&lang=js"
export * from "./DemoStorage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/DemoStorage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3484ac58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3484ac58', __exports__)) {
    console.log('reload')
    api.reload('3484ac58', __exports__)
  }
  
  module.hot.accept("./DemoStorage.vue?vue&type=template&id=3484ac58", () => {
    console.log('re-render')
    api.rerender('3484ac58', render)
  })

}


export default __exports__